module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Forward-d59188b2e21b3b3a6ca42f2367786e50.svg";